var map = {
	"./i18n-demo/en-US": 36
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;


//////////////////
// WEBPACK FOOTER
// ./src/lang ^\.\/.*\/en\-US$
// module id = 35
// module chunks = 1 2 3 4